<template>
  <div class="com-title">
    <div class="title" v-if="title">{{ title }}</div>
    <div class="sub-title" v-if="subTitle">{{ subTitle }}</div>
    <div class="content-title" v-if="contentTitle">{{ contentTitle }}</div>
    <div class="second-title" v-if="secondTitle">{{ secondTitle }}</div>
    <div class="content" v-html="content" />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    contentTitle: {
      type: String,
      default: "",
    },
    secondTitle: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.com-title {
  width: 100%;
  text-align: center;
  .title {
    font-family: Arial-BoldMT;
    color: #336699;
    font-size: 26px;
    font-weight: bold;
    line-height: 30px;
    margin-bottom: 0.9vw;
  }
  .sub-title {
    font-size: 26px;
    font-family: Arial-BoldMT;
    font-weight: bold;
    color: #333;
    line-height: 30px;
    margin-bottom: 5.5vw;
  }

  .content-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    font-weight: bold;
    color: #333;
    line-height: 32px;
    margin-top: 102px;
    margin-bottom: 100px;
  }
  .content {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    color: #333;
    line-height: 30px;
  }
  .second-title {
    font-size: 1.5vw;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    line-height: 32px;
    margin-bottom: 2vw;
  }
}
</style>
